import QuizStats from "../../../../../models/QuizStat";

export function getQuizMarksTotal(quizStat?: QuizStats) {
  return quizStat?.marksTotal;
}

export function getQuizTotalStudyTime(quizStat?: QuizStats) {
  return quizStat?.totalStudyTime;
}

export function getQuizModuleStats(quizStat?: QuizStats) {
  return quizStat?.moduleStats;
}
